import { type AdditionalFinancingOption } from './CohortSectionOffer.types';

export const DISCUSS_OTHER_OPTIONS = 'discuss_other_options';

export const ADDITIONAL_FINANCING_OPTIONS = [
    {
        label: 'Quantic / 26 months / 14% APR',
        monthlyDuration: 26,
        apr: 0.14,
    },
    {
        label: 'Quantic / 30 months / 14% APR',
        monthlyDuration: 30,
        apr: 0.14,
    },
    {
        label: 'Quantic / 52 months / 14% APR',
        monthlyDuration: 52,
        apr: 0.14,
    },
    {
        label: 'Quantic / 60 months / 14% APR',
        monthlyDuration: 60,
        apr: 0.14,
    },
    {
        label: 'Valar / 24 months / 14% APR',
        monthlyDuration: 24,
        apr: 0.14,
    },
    {
        label: 'Valar / 48 months / 14% APR',
        monthlyDuration: 48,
        apr: 0.14,
    },
    {
        label: DISCUSS_OTHER_OPTIONS,
        monthlyDuration: 0,
        apr: 0,
    },
] as AdditionalFinancingOption[];
